// Environment variables configuration
// All REACT_APP_* variables are loaded from .env files

const getEnvVariable = (key: string, defaultValue?: string): string => {
  const value = process.env[key];
  
  if (value === undefined) {
    if (defaultValue !== undefined) {
      return defaultValue;
    }
    console.warn(`Environment variable ${key} is not defined. Using default value: ${defaultValue}`);
    return defaultValue || '';
  }
  
  return value;
};

export const Config = {
  // API Configuration
  BASE_URL: getEnvVariable('REACT_APP_API_BASE_URL'),
  API_ADMIN_PATH: getEnvVariable('REACT_APP_API_ADMIN_PATH'),
  
  // Storage URLs (DigitalOcean Spaces)
  THERAPIST_AVATAR_BASE_URL: getEnvVariable(
    'REACT_APP_THERAPIST_AVATAR_BASE_URL'
  ),
  USER_AVATAR_BASE_URL: getEnvVariable(
    'REACT_APP_USER_AVATAR_BASE_URL'
  ),
  PARTNER_LOGO_BASE_URL: getEnvVariable(
    'REACT_APP_PARTNER_LOGO_BASE_URL'
  ),
  
  // External URLs
  LANDING_THERAPIST_URL: getEnvVariable(
    'REACT_APP_LANDING_THERAPIST_URL'
  ),
  LANDING_USER_URL: getEnvVariable(
    'REACT_APP_LANDING_USER_URL'
  ),
  PRIVACY_POLICY_URL: getEnvVariable(
    'REACT_APP_PRIVACY_POLICY_URL'
  ),
  TERMS_OF_SERVICE_URL: getEnvVariable(
    'REACT_APP_TERMS_OF_SERVICE_URL'
  ),
  
  // App Stores
  ANDROID_STORE_URL: getEnvVariable(
    'REACT_APP_ANDROID_STORE_URL'
  ),
  IOS_STORE_URL: getEnvVariable(
    'REACT_APP_IOS_STORE_URL'
  ),
  
  // App Info
  BUILD_VERSION: getEnvVariable('REACT_APP_BUILD_VERSION'),
  ENVIRONMENT: getEnvVariable('REACT_APP_ENVIRONMENT'),

  // Aliases for backward compatibility
  buildVersion: getEnvVariable('REACT_APP_BUILD_VERSION'),

  // Computed values
  getFullApiUrl: (): string => {
    return `${Config.BASE_URL}${Config.API_ADMIN_PATH}`;
  },

  // Environment checks
  isDevelopment: (): boolean => Config.ENVIRONMENT === 'development',
  isStaging: (): boolean => Config.ENVIRONMENT === 'staging',
  isProduction: (): boolean => Config.ENVIRONMENT === 'production',
};

// Validate required environment variables in development
if (process.env.NODE_ENV === 'development') {
  const requiredVars = [
    'REACT_APP_API_BASE_URL',
    'REACT_APP_THERAPIST_AVATAR_BASE_URL',
    'REACT_APP_USER_AVATAR_BASE_URL',
  ];
  
  requiredVars.forEach(varName => {
    if (!process.env[varName]) {
      console.warn(
        `⚠️  Required environment variable ${varName} is not defined. ` +
        'Please check your .env file.'
      );
    }
  });
}
